import { render } from "./publicNotFound.vue?vue&type=template&id=449f99c7&scoped=true"
import script from "./publicNotFound.vue?vue&type=script&lang=js"
export * from "./publicNotFound.vue?vue&type=script&lang=js"

import "./publicNotFound.vue?vue&type=style&index=0&id=449f99c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449f99c7"]])

export default __exports__